export enum ECookiesStorageKeys {
  TransactionGUID = 'transactionGUID',
  OrderFormData = 'orderFormData',
  UserEmail = 'userEmail',
  CountryResidence = 'countryResidence',
  TransactionFilters = 'transactionFilters',
  TransactionSignatureData = 'transactionSignatureData',
  Theme = 'theme',
  ThemeSelector = 'themeSelector',
  FpfFinalStepRedirect = 'fpfFinalStepRedirect',
}
